import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AuthGuard,
  CmsConfig,
  I18nModule,
  PageMetaModule,
  provideConfig
} from '@spartacus/core';
import { KbBreadcrumbComponent } from './breadcrumb.component';

@NgModule({
  declarations: [KbBreadcrumbComponent],
  exports: [KbBreadcrumbComponent],
  imports: [CommonModule, RouterModule, PageMetaModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        BreadcrumbComponent: {
          component: KbBreadcrumbComponent,
        },
      },
    }),
  ],
})
export class KbBreadcrumbModule { }
